import React from "react";
import { useTranslation } from "react-i18next";

import { useLocationSelect } from "./hooks";
import Checkbox from "../../FormElement/Checkbox";

import "./styles.scss";

interface ILocationSelectProps {
  locationSelect: ReturnType<typeof useLocationSelect>;
}

export const LocationSelect: React.FC<ILocationSelectProps> = ({
  locationSelect,
}) => {
  const {
    allLocations,
    selectedLocations,
    toggleLocation,
    selectAll,
    clearSelection,
    labels,
    selectedLabelIds,
    toggleLabel,
    clearLabels,
  } = locationSelect;

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`dataDownloadPage.locationSelect.${key}`);

  return (
    <div className="location-select">
      {labels.length > 0 && (
        <div className="location-select-labels">
          <span className="location-select-labels-title">
            {t("filter_by_label")}
          </span>
          {labels.map((label) => (
            <button
              key={label.id}
              type="button"
              className={`location-select-label ${
                selectedLabelIds.includes(label.id) ? "active" : ""
              }`}
              aria-pressed={selectedLabelIds.includes(label.id)}
              onClick={() => toggleLabel(label)}
            >
              {label.name}
            </button>
          ))}
          {selectedLabelIds.length > 0 && (
            <button
              type="button"
              className="location-select-labels-clear"
              onClick={clearLabels}
            >
              {t("clear_labels")}
            </button>
          )}
        </div>
      )}
      <div className="location-select-list">
        {allLocations.map((location) => (
          <Checkbox
            key={location.id}
            checked={selectedLocations.some((l) => l.id === location.id)}
            onChange={() => toggleLocation(location)}
            id={location.id.toString()}
            label={location.name}
            className="location-select-checkbox"
          />
        ))}
        {allLocations.length === 0 && selectedLabelIds.length > 0 && (
          <span className="location-select-empty">
            {t("no_locations_with_labels")}
          </span>
        )}
      </div>
      <div className="location-select-controls">
        <button className="btn btn-blue" onClick={selectAll}>
          {t("select_all")}
        </button>
        <button className="btn btn-border" onClick={clearSelection}>
          {t("clear_selection")}
        </button>
      </div>
    </div>
  );
};
